import UserLinkCard from './user-link-card-view';

export default UserLinkCard;
